// extracted by mini-css-extract-plugin
export default {"card-list":"CardList_card-list__IZgwY"};